import { render, staticRenderFns } from "./Cohort.vue?vue&type=template&id=c6f4ab4e&scoped=true&"
import script from "./Cohort.vue?vue&type=script&lang=js&"
export * from "./Cohort.vue?vue&type=script&lang=js&"
import style0 from "./Cohort.vue?vue&type=style&index=0&id=c6f4ab4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f4ab4e",
  null
  
)

export default component.exports